import { confirmLinkJump } from "@/utils/public"
import GoLink from "@/static/golink.png"
import { useBlockNoSameDomainClick } from "@sui/chat-ui"

const titleNode = (
  <div className='jump-tips'>
    您访问的链接即将跳转当前网站，是否继续？
    {/* <img src={GoLink} width="160" alt="链接" /> */}
    {/* <br /> */}
    {/* 是否继续？ */}
  </div>
)

function HTMLCard(props) {
  const { msg } = props
  const handleClick = useBlockNoSameDomainClick()
  // const handleClick = (e: any) => {
  //   const currentTarget = e.target;
  //   if (currentTarget.tagName.toLowerCase() === "a") {
  //     confirmLinkJump(e, currentTarget.href, titleNode);
  //   }
  // };

  const htmlContext = () => {
    return {
      __html: msg.html,
    }
  }
  return (
    <div className='card_hyper-links'>
      <div className='msg-line'>
        <div dangerouslySetInnerHTML={htmlContext()} onClick={handleClick}></div>
      </div>
    </div>
  )
}

export default HTMLCard
